import $ from 'jquery';
import * as dropdownPopup from "./cofman/components/dropdown-popup";
import * as searchArrivalPicker from "./cofman/components/search-arrival-picker";
import * as datePicker from "./cofman/components/date-picker";
import * as searchResultDecorator from "./cofman/search-result-decorator";
import * as searchformExtend from "./cofman/searchform-extend";
import * as selector from './cofman/selector';
import * as carousel from "./cofman/carousel";

dropdownPopup.registerComponent();
searchArrivalPicker.registerComponent();
datePicker.registerComponent();

searchResultDecorator.init();
searchformExtend.init();
selector.init();
carousel.init();
